import styled from 'styled-components'

export const LoadingBox = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
`